/**
 * Bridge the existing async Shopify recommendation/history loader to ET's shared
 * native carousel. This module does not fetch products, read/write browsing
 * history, add autoplay or duplicate the homepage controller.
 * Observe only direct response replacement, not every card/control mutation.
 */
(() => {
  'use strict';
  if (customElements.get('etr-pdp-carousel')) return;

  class ETPdpCarousel extends HTMLElement {
    connectedCallback() {
      // Editor moves can reconnect an element; keep one observer per instance.
      this.observer?.disconnect();
      this.observer = new MutationObserver(() => this.connectRegion());
      this.observer.observe(this, { childList: true });
      this.connectRegion();
    }

    /** Reuse controls after injection, releasing any superseded response first. */
    connectRegion() {
      const region = this.querySelector('.et-nt-carousel-region');
      if (region === this.region) return;
      if (this.region) window.ETNativeCarousel.destroy(this.region);
      this.region = region;
      if (!region) return;
      window.ETNativeCarousel.init(region);
      this.setAttribute('aria-busy', 'false');
    }

    /** Theme editor unloads must release resize observers and event listeners. */
    disconnectedCallback() {
      this.observer?.disconnect();
      if (this.region) window.ETNativeCarousel.destroy(this.region);
      this.region = null;
    }
  }

  customElements.define('etr-pdp-carousel', ETPdpCarousel);
})();
